<!-- src/views/demand/demand-cooperation-list.vue -->
<template>
	<div class="app-body">
		<div class="a-flex-rsbc a-ptb-6">
			<bread-crumb></bread-crumb>
		</div>

		<el-card class="el-main">
			<el-table :data="tableData" :highlight-current-row="true" ref="supplyContractList" v-sticky="{ top: 0, parent:'.el-card__body' }">
                <el-table-column prop="description" label="查看人" min-width="200" >
                    <template slot-scope="{ row }">
                        <span>{{ row.intentUserName }} {{ row.intentUserPhone }}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="imageCount" label="查看时间" min-width="200">
                    <template slot-scope="{ row }">
                        <span>{{ row.createTime || '-' }}</span>
                    </template>
                </el-table-column>
            </el-table>
		</el-card>
	</div>
</template>

<script>
import util from "../../utils/util.js";
export default {
	data() {
		return {
			util: util,
			tableData: [],
            supplyId: ''
		};
	},
	mounted() {
        // 获取路由参数中的 demandId
        this.supplyId = this.$route.query.supplyId;
        if (this.supplyId) {
            this.getTableData();
        }
	},
	methods: {
        getTableData () {
            this.$Axios._post({
                url: this.$Config.apiUrl.supplyBackIntentionList,
                method: 'post',
                params: {
                    supplyDemandId: this.supplyId,
                }
            }).then(({data}) => {
                this.tableData = data;
            }).catch(() => {
                
            });
        },
        // 获取图片数量
        getImageCount(imageUrls) {
            if (!imageUrls) return 0;
            try {
                const images = JSON.parse(imageUrls);
                return Array.isArray(images) ? images.length : 0;
            } catch (e) {
                return 0;
            }
        },

        // 获取图片列表
        getImageList(imageUrls) {
            if (!imageUrls) return [];
            try {
                const images = JSON.parse(imageUrls);
                return Array.isArray(images) ? images : [];
            } catch (e) {
                return [];
            }
        },
	}
};
</script>

<style scoped lang="scss">

.image-attachment {
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
}

.image-count {
	font-size: 12px;
	color: #999;
	margin-top: 4px;
}

.status-tag {
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
}

.status-tag.pending {
	background-color: #f5f5f5;
	color: #999;
}

.el-button--mini {
	padding: 4px 8px;
	font-size: 12px;
}

/* 操作按钮间距 */
.el-button + .el-button {
	margin-left: 8px;
}
</style>